import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import FigmaFrame from "../layouts/FigmaFrame";
import UiUxProjectPageData from "../Data/UiUxPageData/UiUxProjectPageData";
import TagBadges from "../components/UiUxPageComps/TagBadges/TagBadges";
import ShareSocialButtonsGroup from "../components/UiUxPageComps/ShareSocialButtonsGroup/ShareSocialButtonsGroup";
import ButtonsGroup from "../components/UiUxPageComps/ButtonsGroup/ButtonsGroup";
import UiUxDescription from "../components/UiUxPageComps/UiUxDescription/UiUxDescription";
import TestimonialSlider from "../components/TestimonialSlider/TestimonialSlider";
import usePageMeta from "../Helpers/usePageMeta";

// Each project's description[0].descriptionContent is a full paragraph;
// trim it to meta-description length, preferring a sentence boundary.
const truncate = (text, maxLength = 155) => {
  if (!text || text.length <= maxLength) return text;
  const cut = text.slice(0, maxLength);
  const lastSentenceEnd = Math.max(
    cut.lastIndexOf(". "),
    cut.lastIndexOf("! "),
    cut.lastIndexOf("? ")
  );
  if (lastSentenceEnd > 60) {
    return cut.slice(0, lastSentenceEnd + 1);
  }
  const lastSpace = cut.lastIndexOf(" ");
  return `${cut.slice(0, lastSpace > 0 ? lastSpace : maxLength)}...`;
};

const UiUxProjectPage = () => {
  const { id } = useParams();
  // const location = useLocation();

  // console.log("Loc URL", location.pathname.split("/")[2]);

  const [pageContentProps, setPageContentProps] = useState(null);
  const [breadcrumbProps, setBreadcrumbProps] = useState(null);

  const item = UiUxProjectPageData[id];

  useEffect(() => {
    if (id) {
      if (item) {
        setBreadcrumbProps({
          pageName: item?.pageName,
          menuName: item?.menuName,
        });
        setPageContentProps({
          pageName: item?.pageName,
          menuName: item?.menuName,
          description: item?.description,
          FigmaDesignLink: item?.ProjectLinks?.FigmaDesignLink,
          FigmaDesignEmmbedLink: item?.ProjectLinks?.FigmaDesignEmmbedLink,
          FigmaPrototypeLink: item?.ProjectLinks?.FigmaPrototypeLink,
          FigmaPrototypeEmbbedLink:
            item?.ProjectLinks?.FigmaPrototypeEmbbedLink,
          buttonsGroup: item?.buttonsGroup,
          tags: item?.tags,
          socialShareUrl: item?.socialShareUrl,
        });
      }
    }
  }, [id, item]);

  usePageMeta({
    title: item?.pageName ? `${item.pageName} | TZ Creation` : undefined,
    description: truncate(item?.description?.[0]?.descriptionContent),
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div style={{ color: "#777777" }}>
      <Header />
      <Breadcrumb
        parentpageName="Home"
        currentPageName="Ui/Ux Projects"
        breadcrumbProps={breadcrumbProps}
      />
      <section className="services-area section-gap" id="FigmaPage">
        <div>
          <div className="row d-flex">
            <div className="menu-content col-lg-12">
              <div className="title">
                <h1 className="mb-4">{pageContentProps?.pageName}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 px-0">
                <FigmaFrame url={pageContentProps?.FigmaDesignEmmbedLink} />
              </div>
            </div>
            <div className="row py-4">
              <div className="col-sm-12 col-md-9 description-section">
                <UiUxDescription pageContentProps={pageContentProps} />
              </div>
              <div className="col-sm-12 col-md-3 details-section">
                {pageContentProps?.buttonsGroup && (
                  <ButtonsGroup pageContentProps={pageContentProps} />
                )}
                {pageContentProps?.socialShareUrl && (
                  <ShareSocialButtonsGroup
                    url={pageContentProps?.socialShareUrl}
                  />
                )}
                {pageContentProps?.tags && (
                  <TagBadges pageContentProps={pageContentProps} />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <TestimonialSlider />
      <Footer />
    </div>
  );
};

export default UiUxProjectPage;
